<template>
  <div class="operation-manage-container">
    <header>
      <span class="title">运营管理</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="客户名称/功能名称" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-date-picker v-model="value1" size="small" type="date" placeholder="选择日期" value-format="timestamp" @change="queryDataembeddingpointList" style="margin-left:10px;"></el-date-picker>
        <el-button type="primary" size="small" @click="dataEmbeddingpointExport" v-if="funAuth.includes(69)">导出</el-button>
      </div>
    </header>
    <el-table :data="tableList" tooltip-effect='dark' style='width: 100%;' class="el-table-01">
      <el-table-column prop='company_name' label="客户名称" min-width="140" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="操作时间" min-width="140">
        <template slot-scope='scope'>{{ scope.row.operation_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
      </el-table-column>
      <el-table-column prop="function_name" label="埋点功能名称" min-width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="phone" label="手机号码" min-width="120"></el-table-column>
      <el-table-column prop="operation_count" label="数量" min-width="70"></el-table-column>
      <el-table-column prop="operation_content" label="内容" min-width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="ip" label="IP" min-width="100"></el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes='[10, 20, 50, 100]' :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="tableTotal"></el-pagination>
  </div>
</template>
<script>
import axios from 'axios'
import {baseURL, HTTPServer} from '@/common/js/ajax.js'
import mixin from '@/common/js/mixins.js'
import { Loading } from 'element-ui'

export default {
  data () {
    return {
      defaultMsg: '<b>运营管理</b>',
      funAuth: [],
      searchInput: '',
      tableList: [],
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      status: '',
      value1: ''
    }
  },
  mixins: [mixin],
  mounted () {
    this.searchValue = ''
    this.queryFchBtnAuth({moduleId: 22})
    this.queryDataembeddingpointList()
  },
  methods: {
    /** 获取列表 */
    queryDataembeddingpointList () {
      var jsondata = {
        'pageNum': this.pageNum,
        'pageSize': this.pageSize,
        'queryWhere': {
          'keyword': this.searchValue,
          'companyId': '',
          'operationTime': {}
        }
      }
      if (this.value1) {
        jsondata.queryWhere.operationTime.startTime = this.value1
        jsondata.queryWhere.operationTime.endTime = this.value1 + 86399999
      }
      console.log(jsondata)
      HTTPServer.queryDataembeddingpointList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryDataembeddingpointList()
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = (this.multipleSelection.length === 0)
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryDataembeddingpointList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryDataembeddingpointList()
    },
    // 导出
    dataEmbeddingpointExport () {
      var jsondata = {
        'pageNum': this.pageNum,
        'pageSize': this.pageSize,
        'queryWhere': {
          'keyword': this.searchValue,
          'companyId': '',
          'operationTime': {}
        }
      }
      if (this.value1) {
        jsondata.queryWhere.operationTime.startTime = this.value1
        jsondata.queryWhere.operationTime.endTime = this.value1 + 86399999
      }
      console.log(jsondata)
      let options = {
        lock: true,
        text: 'Loading…',
        background: 'rgba(0, 0, 0, 0.4)'
      }
      let loadingInstance = Loading.service(options)
      let requestHeader = JSON.parse(sessionStorage.requestHeader)
      axios({
        method: 'post',
        responseType: 'blob',
        url: 'dataembeddingpoint/dataEmbeddingpointExport',
        baseURL: baseURL,
        data: jsondata,
        headers: requestHeader
      })
        .then((response) => {
          console.log(111, response)
          var blob = new Blob([response.data], {type: response.headers['content-type']}) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
          var downloadElement = document.createElement('a')
          var href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = href
          downloadElement.download = '运营管理.csv' // 下载后文件名
          // let contentDisposition = response.headers['content-disposition'] // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          // let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*")
          // console.log(222, contentDisposition)
          // let result = patt.exec(contentDisposition)
          // console.log(333, result)
          // let filename = decodeURI(result[1])
          // downloadElement.style.display = 'none'
          // downloadElement.download = filename //下载后文件名

          document.body.appendChild(downloadElement)
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
          loadingInstance.close()
        })
        .catch(function (error) {
          console.log(error)
          loadingInstance.close()
        })
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/monitor/operation-manage.vue